interface IAgGridLoaderComponent {
    className?: string;
    loadingText?: string;
}
const AgGridLoaderComponent: React.FC<IAgGridLoaderComponent> = ({
    className,
    loadingText = "Loading",
}) => {
    return (
        <>
            <div
                className={`d-flex align-items-center justify-content-center h-100 ${
                    className ? className : "no-reports-available"
                }`}
                style={{
                    fontSize: "1.5rem",
                    color: "gray",
                }}
            >
                <span
                    className="display-6 tada d-flex flex-column align-items-center"
                    data-testid="loading-text"
                    style={{
                        opacity: "0.71",
                    }}
                >
                    <div
                        className="spinner-border"
                        style={{
                            width: "3rem",
                            height: "3rem",
                        }}
                        role="status"
                    ></div>
                    <div className="mt-4">{loadingText}</div>
                </span>
            </div>
        </>
    );
};

export default AgGridLoaderComponent;